import { render, staticRenderFns } from "./Subscriptions.vue?vue&type=template&id=389a31c5&scoped=true&"
import script from "./Subscriptions.vue?vue&type=script&lang=ts&"
export * from "./Subscriptions.vue?vue&type=script&lang=ts&"
import style0 from "./Subscriptions.vue?vue&type=style&index=0&id=389a31c5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "389a31c5",
  null
  
)

export default component.exports